export type ReceivablePayableNavLink = {
  label: "Accounts Receivable" | "Accounts Payable";
  href: "/accounting/accounts-receivable/invoices" | "/accounting/accounts-payable/bills";
  activePath: "/accounting/accounts-receivable" | "/accounting/accounts-payable";
};

export type ReceivablePayableNavPermissionFlags = {
  hasAccountsReceivableViewPermission: boolean;
  hasAccountsPayableViewPermission: boolean;
};

/** Pure AR/AP sidebar link builder — permission flags are computed in Navbar. */
export const buildReceivablePayableNavLinks = (flags: ReceivablePayableNavPermissionFlags): ReceivablePayableNavLink[] => {
  const links: ReceivablePayableNavLink[] = [];

  if (flags.hasAccountsReceivableViewPermission) {
    links.push({
      label: "Accounts Receivable",
      href: "/accounting/accounts-receivable/invoices",
      activePath: "/accounting/accounts-receivable",
    });
  }

  if (flags.hasAccountsPayableViewPermission) {
    links.push({
      label: "Accounts Payable",
      href: "/accounting/accounts-payable/bills",
      activePath: "/accounting/accounts-payable",
    });
  }

  return links;
};
